import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { Scale, HandCoins, HeartPulse, MapPin, ArrowUpRight } from "lucide-react";
import { IMG } from "@/lib/images";

const PILLARS = [
  {
    n: "01",
    icon: Scale,
    title: "I diritti del debitore",
    text: "Legge 3/2012, esdebitazione, limiti al pignoramento: guide chiare e gratuite per sapere cosa puoi fare davvero.",
    to: "/guide",
    cta: "Leggi le guide",
    color: "bg-brand-blue",
    image: IMG.listening,
  },
  {
    n: "02",
    icon: HandCoins,
    title: "L'8 per mille",
    text: "Una firma nella dichiarazione dei redditi che non ti costa nulla e ci permette di assistere gratuitamente sempre più persone.",
    to: "/#otto-per-mille",
    cta: "Scopri come",
    color: "bg-brand-aqua",
    image: IMG.solidarity,
  },
  {
    n: "03",
    icon: HeartPulse,
    title: "Supporto psicologico",
    text: "Grazie alla collaborazione della Dott.ssa V. Graffeo, psicologa professionista, offriamo colloqui telefonici gratuiti ai casi di maggiore necessità. Perché il debito pesa anche sul cuore.",
    to: "/assistenza",
    cta: "Chiedi supporto",
    color: "bg-[#c24e2c]",
    image: IMG.smiling,
  },
  {
    n: "04",
    icon: MapPin,
    title: "Vicini a te, sul territorio",
    text: "Sede legale a Milano in Via Pordenone 13 e sede operativa a Gallarate in Via Scipione Ronchetti 8. Ci trovi anche online.",
    to: "/#sedi",
    cta: "Vedi le sedi",
    color: "bg-brand-bluedark",
    image: IMG.community,
  },
];

export default function Pillars() {
  return (
    <section data-testid="pillars-section" className="bg-brand-mist py-20 lg:py-28">
      <div className="container-site">
        <Reveal className="max-w-2xl">
          <span className="eyebrow">Cosa facciamo</span>
          <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-ink">
            Quattro impegni concreti, un solo obiettivo: te.
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PILLARS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.1}>
              <div className="group relative bg-white rounded-3xl border border-slate-100 p-8 shadow-sm hover:shadow-xl hover:shadow-brand-blue/8 transition-shadow duration-300 h-full" data-testid={`pillar-card-${p.n}`}>
                <div className="rounded-2xl overflow-hidden mb-6">
                  <img src={p.image.url} alt={p.image.alt} loading="lazy" className="w-full h-40 object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="flex items-start justify-between">
                  <span className={`w-12 h-12 rounded-2xl ${p.color} text-white flex items-center justify-center`}>
                    <p.icon className="w-6 h-6" />
                  </span>
                  <span className="text-5xl font-extrabold text-slate-100 group-hover:text-brand-blue/15 transition-colors duration-300">
                    {p.n}
                  </span>
                </div>
                <h3 className="mt-5 text-xl font-bold text-brand-ink">{p.title}</h3>
                <p className="mt-3 text-slate-600 leading-relaxed">{p.text}</p>
                {p.to.startsWith("/#") ? (
                  <a href={p.to.slice(1)} className="mt-5 inline-flex items-center gap-1.5 font-bold text-brand-blue hover:gap-3 transition-all" data-testid={`pillar-link-${p.n}`}>
                    {p.cta} <ArrowUpRight className="w-4 h-4" />
                  </a>
                ) : (
                  <Link to={p.to} className="mt-5 inline-flex items-center gap-1.5 font-bold text-brand-blue hover:gap-3 transition-all" data-testid={`pillar-link-${p.n}`}>
                    {p.cta} <ArrowUpRight className="w-4 h-4" />
                  </Link>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
